import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  imageContainer: {
    marginTop: 48,
    marginBottom: 48,
    display: 'flex',
    alignItems: 'center',
  },
}));
